import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom';
import {Card, CardFooter,CardHeader, CardBody,Box,Button,Heading, Text,Layer, NameValueList, NameValuePair,CheckBox } from 'grommet';
import {Close,Package, Launch } from 'grommet-icons';
import {ReturnRowDir} from './utils/shared/shared'
import { ReturnLocation} from './utils/shared/shipmentViewFunctions';
import moment from 'moment'

function returnTotalWeight(pieces){
    let weight = 0;
    let volumetricWeight = 0;
    pieces.forEach(pack => {
        var a = parseFloat(pack.weight)
        weight += a
        var b = (parseFloat(pack.length) * parseFloat(pack.width) * parseFloat(pack.height))/5000
        volumetricWeight += b
    })

    if (weight > volumetricWeight){
        return (<NameValuePair  name={<Text weight='bold' size='small'>Total Weight</Text>}><Text size='small'>{weight} KG</Text></NameValuePair>)
    } else {
        return (<NameValuePair  name={<Text weight='bold' size='small'>Total Weight</Text>}><Text margin={'xsmall'} size='small'>{volumetricWeight} KG (Volumetric)</Text></NameValuePair>)
    }
}


function returnCommodity(commodity, pieces,quote,showQuote){
    var totalCustomsValue = 0
    pieces.forEach(piece => {
       totalCustomsValue += parseFloat(piece.customsValue)
    })
    return (
        <Card margin={'small'} pad="medium"  round elevation='large' style={{maxWidth:300}}>
            <CardHeader margin={'xsmall'} direction='row' justify='start'>
                <Package color='brand'/><Text weight={'bold'} size="medium">Shipment Details</Text><Box></Box>
            </CardHeader>
            <CardBody margin={'small'} overflow='scroll' direction='column'>
                <NameValueList layout='grid' margin='small' nameProps={{ width: 'xxsmall' }}  pairProps={{ direction: 'column' }}>
                    <NameValuePair name={<Text weight='bold' size='small'>Number of Pieces</Text>}>
                        <Text size='small'>{pieces.length}</Text>
                    </NameValuePair>
                    <NameValuePair  name={<Text weight='bold' size='small'>Commodity</Text>}>
                        {pieces.map(piece => {
                            return <Text  size='small'>• {piece.commodity.name}</Text>
                        })}
                    </NameValuePair>
                    <NameValuePair  name={<Text weight='bold' size='small'>Declared Customs Value</Text>}>
                        <Text  size='small'>${totalCustomsValue} USD</Text>
                    </NameValuePair>
                    {returnTotalWeight(pieces)}
                    {(commodity.requestPickup &&  
                               <NameValuePair  name={<Text weight='bold' size='small'>Collection Date/Time</Text>}>
                               <Text  size='small'>{moment(commodity.collectionDate).format("DD/MM/YYYY")} {commodity.collectionTime} - {commodity.pickupCloseTime} </Text>
                           </NameValuePair>
                    )}
                    {(showQuote && quote &&
                            <NameValuePair  name={<Text weight='bold' size='small'>Quote</Text>}>
                                <Text  size='small'>${quote.quote.total_quote_price} {quote.quote.total_quote_price_currency}</Text>
                            </NameValuePair>
                        )}
                   
                </NameValueList>
            </CardBody>
        </Card>
    )
}


function ShipmentSummary(props) {
    const shipmentSummaryData = props.shipmentPieceDetails
    const showLayer = props.showLayer
    useEffect(() => {   
        shipmentSummaryData.forEach((piece,i) => {
            piece.number = i +1
        })
    },[shipmentSummaryData]);
  return (
      
      <Box>
        {/* Collection Details/Time  */}
        {showLayer && (
          <Layer animation="fadeIn" margin={'small'} gap='small'>
            <Box alignSelf='center' background='background-front' elevation='large'  gap="small" direction='column' width='xxlarge'>
            <CardHeader direction='row' border='bottom' justify='center' margin={'small'}>
                <Heading margin='small' level={3}>Shipment Summary</Heading>
            </CardHeader>
            <CardBody overflow='scroll' gap='xsmall'>
                <Text weight={'bold'} margin={{left:'medium'}} size='small'>Please ensure the details below are correct before proceeding with your shipment.</Text>
                <Box direction={ReturnRowDir(props.size)} gap='xsmall' margin='small'>
                <ReturnLocation location={props.origin} locationType={"Origin"} />

                {returnCommodity(props.value, shipmentSummaryData, props.quote,props.showQuote)}

                <ReturnLocation location={props.destination} locationType={"Destination"} />

                </Box>
                {/* <Box gap='small' margin={'small'} direction='row'>
                <CollectionDetailsCard load={false} collection={props.value} />
                {props.showQuote && (<QuoteCardShip size={props.size} quote={props.quote} load={props.load} />)}
                </Box> */}
                <Box margin='small' elevation='large' round gap='small' background='background-front' direction='row' style={{marginTop:10}} width='large'>
                    <Text pad='small' margin='small' size='small'>Would you like to recieve an email about this shipment to {props.origin.contact.contactEmail}?</Text>
                    <CheckBox pad='small' margin='small' checked={props.shipmentNotifications} onChange={props.setShipmentNotifications} />
                </Box> 
                <Box border='top' justify='center'><Text size='small' weight='bold' alignSelf='center' margin='small' level={5} >Would you like to proceed with this Shipment?</Text></Box>
            </CardBody>
             <CardFooter justify='center'>
             <Button margin='small' alignSelf='center' primary color='status-critical' label="Cancel" icon={<Close />} onClick={() => props.setShowLayer(false)} />
                <Button alignSelf='center' primary color='status-ok' label="Yes" icon={<Launch />} type='submit' onClick={() => props.handleSubmit()} />
             </CardFooter>
            </Box>
          </Layer>
        )}
    </Box>
  )
}

export default withRouter(ShipmentSummary)
